import { createSlice } from '@reduxjs/toolkit';

import {
  getCourses,
  getSchoolCourses,
  updateCourseById,
  removeCourseById,
} from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 10,
};

const coursesSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getCourses.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(getSchoolCourses.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(updateCourseById.fulfilled, (state: any, action: any) => {
      const { fieldName, updatedCourse } = action.payload;

      return {
        ...state,
        data: state.data.map((course: any) => {
          if (course.id === updatedCourse.id) {
            return {
              ...course,
              [fieldName]: updatedCourse[fieldName],
            };
          }

          return course;
        }),
      };
    });

    builder.addCase(removeCourseById, (state: any, action: any) => {
      return {
        ...state,
        data: state.data.filter((course: any) => course.id !== action.payload),
      };
    });
  },
});

export default coursesSlice.reducer;
